module.exports = __webpack_public_path__ + "static/media/spxc.c9c28fa8.jpg";